exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".StatusBox-module__wrapper___1TViG{width:20px;height:20px;color:#fff;border-radius:4px;grid-column:2/3;grid-row:1}", ""]);

// exports
exports.locals = {
	"wrapper": "StatusBox-module__wrapper___1TViG"
};